import React, { createContext, useContext } from 'react'
import { ThemeConfig } from '../utils/themeConfig'

const ThemeContext = createContext<ThemeConfig | undefined>(undefined)

interface ThemeProviderProps {
  children: React.ReactNode
  theme: ThemeConfig
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children, theme }) => {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export const useTheme = (): ThemeConfig => {
  const theme = useContext(ThemeContext)
  if (!theme) {
    throw new Error('Theme context is unavailable. Ensure components are wrapped in ThemeProvider.')
  }
  return theme
}
